import { format } from 'date-fns'

/**
 * Gets the billing time following the same logic as the backend:
 * Users are billed at the end of the day UTC (which corresponds to around 5-6 PM Mountain Time)
 *
 * @returns {string} Formatted time with timezone (e.g., '5:59 PM CT')
 */
export const getPaymentBillingTime = () => {
  try {
    // Create a date at 23:59:59 UTC for today
    // This matches the backend logic: end_of_day in UTC
    const billingTimeUTC = new Date()
    billingTimeUTC.setUTCHours(23, 59, 59, 999)

    // Get user's local timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    // Format in user's local time with timezone abbreviation
    const localTime = format(billingTimeUTC, 'h:mm a')
    const timezoneAbbr = getTimezoneAbbreviation(billingTimeUTC, userTimezone)

    return `${localTime} ${timezoneAbbr}`
  } catch (error) {
    console.error('Error calculating payment billing time:', error)
    return ''
  }
}

/**
 * Gets the timezone abbreviation for a given date and timezone
 * @param {Date} date - The date to get timezone info for
 * @param {string} timezone - The timezone identifier
 * @returns {string} Short timezone name (e.g., 'EST', 'PDT', 'CT')
 */
const getTimezoneAbbreviation = (date, timezone) => {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    })

    const parts = formatter.formatToParts(date)
    const timeZonePart = parts.find(part => part.type === 'timeZoneName')
    return timeZonePart ? timeZonePart.value : ''
  } catch (error) {
    console.error('Error getting timezone abbreviation:', error)
    return ''
  }
}
